import {type QueryClient} from '@tanstack/query-core';
import {lazy, Suspense} from 'react';
import {type LoaderFunction, Outlet} from 'react-router';

import {GlobalProviders} from '@/modules/common/components/GlobalProviders';
import {GlobalSideEffects} from '@/modules/common/components/GlobalSideEffects';
import {GlobalStyles} from '@/modules/common/components/GlobalStyles';
import {Honeepot} from '@/modules/common/components/Honeepot';
import {OmnichannelChat} from '@/modules/common/components/OmnichannelChat';
import {
  configServiceConfigQuery,
  configServiceConfigQueryDefaultParams,
} from '@/modules/common/queries/configService';
import {
  pageServiceSiteQuery,
  pageServiceSiteQueryDefaultParams,
} from '@/modules/common/queries/pageService';

const DebugDrawer = lazy(
  () => import('@/modules/common/components/DebugDrawer')
);

const showDebugDrawer =
  import.meta.env.MODE !== 'production' ||
  window.location.search.includes('featureInfo=on');

type Loader = (queryClient: QueryClient) => LoaderFunction;

export const loader: Loader = (queryClient) => async () => {
  // request critical data as early as possible
  queryClient.prefetchQuery(
    configServiceConfigQuery(configServiceConfigQueryDefaultParams())
  );
  queryClient.prefetchQuery(
    pageServiceSiteQuery(pageServiceSiteQueryDefaultParams())
  );

  return null;
};

export const Component = () => {
  return (
    <GlobalProviders>
      <GlobalStyles />
      <GlobalSideEffects />
      <Outlet />
      <Honeepot />
      <OmnichannelChat />
      {showDebugDrawer && (
        <Suspense fallback={null}>
          <DebugDrawer />
        </Suspense>
      )}
    </GlobalProviders>
  );
};
